import type { ReactNode } from 'react';

export const symbol_rotate_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M804-488q-10 0-18.5-7T775-512q-5-24-14.5-47T737-605q-5-9-4-20t9-19q11-11 25-9.5t22 14.5q16 26 27 54.5t18 60.5q3 14-6 25t-24 11ZM526-116q0-10 7-18.5t17-10.5q23-5 46-14.5t46-23.5q9-5 19.5-4.5T680-179q11 11 9.5 25T675-132q-27 17-55.5 28T562-86q-14 3-25-6t-11-24Zm216-126q-7-7-8-18.5t4-20.5q14-23 23-46t14-47q2-10 10-17t19-7q15 0 23.5 10.5T833-363q-8 32-19 61t-26 55q-8 13-21.5 14.5T742-242ZM401-86q-123-28-201-127t-78-230q0-151 104.5-255.5T482-803h20l-57-57q-9-9-9-22t9-22q9-9 22-9t22 9l110 110q5 5 7 10t2 11q0 6-2 11t-7 10L489-642q-9 9-22 9t-22-9q-9-9-9-22t9-22l57-57h-20q-127 0-213.5 86.5T182-443q0 110 65 190.5T413-146q10 2 17 10.5t7 19.5q0 15-11 24t-25 6Z"
		/>
	</svg>
);
